import moment from "moment";

export const formatFirebaseTime = (creationTimeString: string): string => {
  const dateObject = moment(creationTimeString);

  if (!dateObject.isValid()) {
    console.error("Invalid date string provided:", creationTimeString);
    return "Invalid Date";
  }

  return dateObject.format("DD/MM/YYYY");
};
